/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetOrganizationIdentifiers = require('../../common/services/GetOrganizationIdentifiers');
var GetEntityUsers = require('../services/GetEntityUsers');
var SecUserManagementSectionView = require('../views/SecUserManagementSectionView');

module.exports = {
  channel: 'sc',

  event: 'build:user-management-section-view',

  builder: function(organizationId) {
    return new PlaceholderView({
      viewPromise: buildUserManagementSectionView(organizationId)
    });
  }
};

function buildUserManagementSectionView(organizationId) {
  var deferred = $.Deferred();
  $.when(GetEntityUsers(organizationId), GetOrganizationIdentifiers(organizationId))
    .done(function(entityUsers, organizationIdentifiers) {
      deferred.resolve(
        new SecUserManagementSectionView({
          model: new Backbone.Model({
            organizationId: organizationId,
            organizationIdentifiers: organizationIdentifiers,
            authorizedUsers: entityUsers.authorizedUsers,
            invitedUsers: entityUsers.invitedUsers,
            userAccessLevels: entityUsers.userAccessLevels
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
